const EN = {
  Home: "Home",
  Information: "Information",
  Dashboard: "Dashboard",
  "Information Dashboard": "Information Dashboard",
  "Expected Earnings": "Expected Earnings",
  Daily: "Daily",
  Week: "Week",
  Month: "Month",
  "Daily Sales": "Daily Sales",
  "Sales Name": "Sales Name",
  "Sales This Months": "Sales This Months",
  Orders: "Orders",
  "Orders This Week": "Orders This Week",
  to: "to",
  Goal: "Goal",
  "to Goal": "to Goal",
  New: "New",
  "New Customers This Month": "New Customers This Month",
  Active: "Active",
  "Active Sales": "Active Sales",
  "Recent Orders": "Recent Orders",
  "Item Name": "Item Name",
  "Discount Sales": "Discount Sales",
  "Total Discounted Sales This Month": "Total Discounted Sales This Month",

  Utility: "Utilitas",
  List: "List",
  Hierarchy: "Hierarchy",
  Setup: "Setup",
  Warehouse: "Warehouse",
  "Warehouse Mutation": "Warehouse Mutation",
  "Setup Warehouse": "Setup Warehouse",
  "Sub Warehouse": "Sub Warehouse",
  SubWarehouse: "Sub Warehouse",
  Supplier: "Supplier",
  "Supplier List": "Supplier List",
  "Supplier Name": "Supplier Name",
  Taking: "Taking",

  Customer: "Customer",
  Customers: "Customers",
  Type: "Type",
  "Customer Type": "Customer Type",
  "Customer List": "Customer List",
  "Customer Hierarchy": "Customer Hierarchy",
  "Setup Hierarchy": "Setup Hierarchy",
  Code: "Code",
  "Code Customer": "Code Customer",
  "Code Branch": "Code Branch",
  "Customer Code": "Customer Code",
  Branch: "Branch",
  "Branch Name": "Branch Name",
  "Branch List": "Branch List",
  Store: "Store",
  "Store List": "Store List",
  Payment: "Payment",
  "Payment Type": "Payment Type",
  Address: "Address",
  Province: "Province",
  City: "City",
  District: "District",
  "Sub District": "District",
  "Long Business": "Long Business",
  Phone: "Phone",
  "ID Number": "ID Number",
  "Contact Person": "Contact Person",
  "Contact Person Phone": "Contact Person Phone",
  Tax: "Tax",
  "Tax Status": "Tax Status",
  "Tax List": "Tax List",
  Competitors: "Competitors",
  Item: "Item",
  "Selling (Pack)": "Selling (Pack)",
  "Selling Price": "Selling Price",
  "Turnover/Week": "Turnover/Week",
  "Invoice Limit": "Invoice Limit",
  "Credit Limit": "Credit Limit",
  Note: "Note",

  Value: "Value",
  Parent: "Parent",
  "Warehouse Parent": "Warehouse Parent",
  "Warehouse List": "Warehouse List",

  Unit: "Unit",
  "Unit List": "Unit List",
  Brand: "Brand",
  "Item Brand": "Item Brand",
  "Item Brand List": "Item Brand List",
  "Brand Item": "Brand Item",
  Category: "Category",
  "Item Category": "Item Category",
  "Item Category List": "Item Category List",
  "Category Item": "Category Item",
  "Item Type": "Item Type",
  "Type Item": "Type Item",
  Account: "Account",
  Inventory: "Inventory",
  "Inventory Account": "Inventory Account",

  "Item List": "Item List",
  User: "User",
  "User Assignment": "User Assignment",
  Assignment: "Assignment",
  Route: "Route",
  Roles: "Roles",
  Role: "Role",
  "Name User": "Name User",
  "Set Assignment": "Set Assignment",
  "Update User": "Update User",
  "Delete User": "Delete User",
  "Block User": "Block User",
  "Assignment Choosed": "Assignment Choosed",

  "Approval Transaction": "Approval Transaction",
  "Type Transaction": "Type Transaction",
  "Approval Goods Offer": "Approval Goods Offer",
  "Approval Memo In": "Approval Memo In",
  "Approval Memo Out": "Approval Memo Out",
  "Approval Purchase Order": "Approval Purchase Order",
  "Approval Return Price": "Approval Return Price",
  "Approval Return Selling": "Approval Return Selling",
  "Approval Selling Price": "Approval Selling Price",
  "Approval Taking Goods": "Approval Taking Goods",

  Name: "Name",
  Created: "Created",
  at: "at",
  "Created at": "Created at",
  "Updated at": "Updated at",
  Updated: "Updated",

  All: "All",
  Active: "Active",
  Non: "Non",
  "Non Active": "Non Active",
  Add: "Add",
  "Add Customer Type": "Add Customer Type",
  "Add Customer": "Add Customer",
  "Add Competitors": "Add Competitors",
  "Add Setup Hierarchy": "Add Setup Hierarchy",
  "Add Warehouse": "Add Warehouse",
  "Add Supplier": "Add Supplier",
  "Add Unit": "Add Unit",
  "Add Brand Item": "Add Brand Item",
  "Add Category Item": "Add Category Item",
  "Add Type Item": "Add Type Item",
  "Add Item": "Add Item",
  "Add Role": "Add Role",
  "Add Branch": "Add Branch",
  "Add Store": "Add Store",
  "Add Tax": "Add Tax",
  "Add Offering": "Add Offering",
  "Add Purchase Request": "Add Purchase Request",
  "Add Details": "Add Details",
  "Add Quotation": "Add Quotation",
  "Add Purchase Order": "Add Purchase Order",
  "Add Taking Goods": "Add Taking Goods",
  "Add Receiving": "Add Receiving",
  "Add Acceptance Report": "Add Acceptance Report",
  "Add Invoice": "Add Invoice",
  "Add Warehouse Out": "Add Warehouse Out",
  "Add Warehouse In": "Add Warehouse In",
  "Add Task": "Add Task",
  "Add Schedule": "Add Schedule",
  Save: "Save",
  Close: "Close",
  Action: "Action",
  Edit: "Edit",
  "Edit Config Branch": "Edit Config Branch",
  Delete: "Delete",
  View: "View",
  Show: "Show",
  Print: "Print",
  Convert: "Convert",
  "Choose File": "Choose File",
  Select: "Select",
  "Select...": "Select...",
  "Select Branch": "Select Branch",
  "Select Store": "Select Store",
  "Select Type Customer": "Select Type Customer",
  "Select Type": "Select Type",
  "Select Province": "Select Province",
  "Select City": "Select City",
  "Select District": "Select District",
  "Select Sub District": "Select Sub District",
  "Select Customer Type": "Select Customer Type",
  "Select Warehouse": "Select Warehouse",
  "Select Sub Warehouse": "Select Sub Warehouse",
  "Select Parent": "Select Parent",
  "Select Account": "Select Account",
  "Select Account COA": "Select Account COA",
  "Select Supplier": "Select Supplier",
  "Select Item": "Select Item",
  "Select Item Type": "Select Item Type",
  "Select Unit": "Select Unit",
  "Select Sales": "Select Sales",
  "Select Sales Order": "Select Sales Order",
  "Select/Create The Supplier": "Select/Create The Supplier",
  "Select Week": "Select Week",

  "Upload Files (max 3 items)": "Upload Files (max 3 items)",
  Cash: "Cash",
  Credit: "Credit",
  Supervisior: "Supervisior",

  "Sales Order": "Sales Order",
  "Quotation Request": "Quotation Request",
  "No. Quotation": "No. Quotation",
  "Quote No.": "Quote No.",
  "you can create the temporary supplier with type the name supplier": "you can create the temporary supplier with type the name supplier",
  "Request List": "Request List",
  "Recap PR": "Recap PR",
  "Qty Order": "Qty Order",
  "Qty Mutation": "Qty Mutation",
  "Qty Request": "Qty Request",
  "Set Supplier Request": "Set Supplier Request",
  "Mutation Items": "Mutation Items",

  "Purchase Order": "Purchase Order",
  "No Order": "No Order",
  "Tanggal Order": "Date Order",
  "Grand Total": "Grand Total",
  Remaining: "Remaining",
  "Nett Price": "Nett Price",

  "Duration Rest Up (Minute)": "Duration Rest Up (Minute)",
  "Duration Rest Down (Minute)": "Duration Rest Down (Minute)",
  "Tolerance Rest (Minute)": "Tolerance Rest (Minute)",
  "Tolerance Checkin (Minute)": "Tolerance Checkin (Minute)",
  "Tolerance Checkout (Minute)": "Tolerance Checkout (Minute)",
  "Tolerance Distance (Minute)": "Tolerance Distance (Minute)",
  "Check In Time": "Check In Time",
  "Check Out Time": "Check Out Time",
  Timezone: "Timezone",

  Language: "Language",
  "Select Status": "Select Status",

  Offering: "Offering",
  Receiving: "Receiving",
  Mutation: "Mutation",

  "Purchase Request": "Purchase Request",
  Date: "Date",
  "Purchase Request No.": "Purchase Request No.",
  "No. Request": "No. Request",

  "Waiting For Approval": "Waiting For Approval",
  Procurement: "Procurement",
  "PR Rejected": "PR Rejected",
  "PO Rejected": "PO Rejected",
  "PO Closed": "PO Closed",
  "Waiting Center Approval": "Waiting Center Approval",
  "Waiting Receiving Item": "Waiting Receiving Item",
  "Waiting For Payment": "Waiting For Payment",
  Done: "Done",
  "Warehouse Transfer": "Warehouse Transfer",
  Approved: "Approved",
  Rejected: "Rejected",
  "Waiting HO Approval": "Waiting HO Approval",

  "Taking Goods": "Taking Goods",
  "Taking Goods No.": "Taking Goods No.",

  "PO No": "PO No",
  "Date PO": "Date PO",
  "Date Delivery": "Date Delivery",
  "Discount Percent": "Discount Percent",
  "Discount (Rp)": "Discount (Rp)",
  Price: "Price",
  "Price Nett": "Price Nett",
  "Price Total": "Price Total",
  Total: "Total",
  "Total Price": "Total Price",
  "Total Discount": "Total Discount",
  "Total Tax": "Total Tax",
  "Code Item": "Code Item",
  "Item Code": "Item Code",

  "No PO": "No PO",
  "Band No": "Band No",
  Reamining: "Reamining",
  Qty: "Qty",
  "Receiving (PB)": "Receiving (PB)",
  "No. PB": "No. PB",
  "No. Band": "No. Band",
  Description: "Description",
  "Document No": "Document No",
  "Delivery Date": "Delivery Date",

  "Config Name": "Config Name",
  "Config Branch": "Config Branch",
  Configuration: "Configuration",
  Persentage: "Persentage",
  accSetup: "accSetup",
  "Effective Date": "Effective Date",
  Purchasing: "Purchasing",
  Transaction: "Transaction",
  "Transaction No.": "Transaction No.",
  Order: "Order",
  "Goods Offer": "Goods Offer",
  Return: "Return",
  "Return Date": "Return Date",

  Receipt: "Receipt",
  "Goods Receipt": "Goods Receipt",
  "Receiveing No.": "Receiveing No.",
  "Receiving No": "Receiving No",
  "Receiving Date": "Receiving Date",
  "Document No.": "Document No.",
  "No Order": "No Order",
  "Qty Received": "Qty Received",
  Banderol: "Banderol",
  "Batch No": "Batch No",
  "Remaining Qty": "Remaining Qty",

  "Acceptance Report": "Acceptance Report",
  "Transaction No": "Transaction No",

  "Purchase Invoice": "Purchase Invoice",
  "Invoice No.": "Invoice No.",
  "Invoice Date": "Invoice Date",

  "Supplier Payments": "Supplier Payments",
  "Remaining Payment": "Remaining Payment",

  "Warehouse Out": "Warehouse Out",
  "Warehouse In": "Warehouse In",
  "Plate No.": "Plate No.",
  Expedition: "Expedition",
  "Origin Warehouse": "Origin Warehouse",
  "Destination Warehouse": "Destination Warehouse",
  "Initial Warehouse": "Initial Warehouse",
  "Stock From Purchase Recap": "Stock From Purchase Recap",
  Stock: "Stock",
  "Recceipt No.": "Recceipt No.",
  "Qty Sent": "Qty Sent",

  "Stock Movement": "Stock Movement",
  "Stock Trail": "Stock Trail",
  "Stock Card": "Stock Card",
  "Stock Trail Report": "Stock Trail Report",
  "Date Period": "Date Period",
  "Beginning Stock": "Beginning Stock",
  "Beginning Balance": "Beginning Balance",
  "Qty In": "Qty In",
  "Balance In": "Balance In",
  "Qty Out": "Qty Out",
  "Balance Out": "Balance Out",
  "Ending Stock": "Ending Stock",
  "Ending Balance": "Ending Balance",
  Remark: "Remark",
  "No Data Found": "No Data Found",
  "Week Period": "Week Period",
  Period: "Period",

  Sales: "Sales",
  Schedule: "Schedule",
  "Sales Activities": "Sales Activities",
  "Visit Schedule": "Visit Schedule",
  Employee: "Employee",
  "Select Employee": "Select Employee",
  "Employee Name": "Employee Name",
  type: "type",
  "Single Customer": "Single Customer",

  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",

  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",

  Mon: "Mon",
  Tue: "Tue",
  Wed: "Wed",
  Thu: "Thu",
  Fri: "Fri",
  Sat: "Sat",
  Sun: "Sun",
  "Cash Accounting":"Cash",
  "Bank Account must be fill":"Bank Account must be fill",
  "Ledger must be fill":"Ledger must be fill",
  "Start Date must be fill":"Start Date must be fill",
  "End Date must be fill":"End Date must be fill",
  "Change":"Change",
  "Type Change":"Type Change",
  "By Date":"By Date",
  "By Period":"By Period",
};
export default EN;
